var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9997 7.17163C8.9997 6.61933 9.4474 6.17163 9.9997 6.17163C10.552 6.17163 10.9997 6.61933 10.9997 7.17163V9.00003H12.8284C13.3807 9.00003 13.8284 9.44773 13.8284 10C13.8284 10.5523 13.3807 11 12.8284 11H10.9997V12.8284C10.9997 13.3807 10.552 13.8284 9.9997 13.8284C9.4474 13.8284 8.9997 13.3807 8.9997 12.8284V11H7.17157C6.61929 11 6.17157 10.5523 6.17157 10C6.17157 9.44773 6.61929 9.00003 7.17157 9.00003H8.9997V7.17163Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2H14C16.2091 2 18 3.79086 18 6C20.2091 6 22 7.79086 22 10V18C22 20.2091 20.2091 22 18 22H10C7.79086 22 6 20.2091 6 18C3.79086 18 2 16.2091 2 14V6C2 3.79086 3.79086 2 6 2ZM18 14V8C19.1046 8 20 8.89543 20 10V18C20 19.1046 19.1046 20 18 20H10C8.89543 20 8 19.1046 8 18H14C16.2091 18 18 16.2091 18 14ZM6 4C4.89543 4 4 4.89543 4 6V14C4 15.1046 4.89543 16 6 16H14C15.1046 16 16 15.1046 16 14V6C16 4.89543 15.1046 4 14 4H6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyPlus);
export default __webpack_public_path__ + "static/media/copy_plus.ae4094034a732df8508f0e4ae9e7608f.svg";
export { ForwardRef as ReactComponent };